import Swiper from 'swiper';

if(document.querySelector('.js-carousel-slider')){
	let mainSlider = new Swiper('.js-carousel-slider', {
		autoplay: {
			delay: 3000
		},
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 20
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 5,
				spaceBetween: 20
			},
			1200: {
				slidesPerView: 6,
				spaceBetween: 20
			},
			1440: {
				slidesPerView: 6,
				spaceBetween: 20
			},
			1600: {
				slidesPerView: 6,
				spaceBetween: 20
			},
			1800: {
				slidesPerView: 6,
				spaceBetween: 40
			}
		}
	});
	
	
	try{
		updateSwiper(mainSlider)
	}catch(err){}
}


/** FIXER */
function updateSwiper(swiper) {
  setTimeout(function () {
    swiper.update();
  }, 500);
}